module.exports = __webpack_public_path__ + "images/icons/psp-car-storage-guide/10x40-car.svg";